"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PureMyAccountConsents = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _Loader = _interopRequireDefault(require("../Loader"));
var _submitConsents = _interopRequireDefault(require("../../api/Customer/submitConsents"));
var _consentsHelper = _interopRequireDefault(require("../../util/consentsHelper"));
var _MyAccountConsentsStyled = require("./MyAccountConsentsStyled");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-nested-ternary */

class MyAccountConsents extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "toggleState", state => state === 'accepted' ? 'declined' : 'accepted');
    this.state = {
      updatedConsents: [],
      isSectionDisabled: true,
      isLoading: false,
      isSubmittingPending: false,
      showButtonToUpdate: true
    };
  }
  componentDidMount() {
    const {
      consents
    } = this.props;
    if (consents.length !== 0) {
      this.saveConsentsInState();
    }
  }
  componentDidUpdate(prevProps) {
    const {
      consents
    } = this.props;
    if (prevProps.consents !== consents) {
      this.saveConsentsInState();
    }
  }
  handleClick(e, isConsentDisabled, item) {
    const {
      showConsentsOnly,
      saveConsents
    } = this.props;
    if (e.target.tagName.toLowerCase() === 'a') return; // enable to open link
    if (isConsentDisabled || !showConsentsOnly && item.required) return;
    const {
      updatedConsents
    } = this.state;
    const itemIndex = updatedConsents.findIndex(el => el.name === item.name);
    this.setState(prevState => {
      const copyConsentObj = {
        ...prevState.updatedConsents[itemIndex]
      };
      copyConsentObj.state = this.toggleState(copyConsentObj.state);
      const stateCopy = [...prevState.updatedConsents];
      stateCopy[itemIndex] = copyConsentObj;
      if (showConsentsOnly) {
        saveConsents(stateCopy);
      }
      return {
        ...prevState,
        updatedConsents: stateCopy
      };
    });
  }
  saveConsentsInState() {
    const {
      consents
    } = this.props;
    const showButtonToUpdate = consents.find(el => !el.required);
    this.setState({
      updatedConsents: consents,
      showButtonToUpdate: !!showButtonToUpdate
    });
  }
  updateConsents() {
    const {
      updatedConsents
    } = this.state;
    const {
      setConsents
    } = this.props;
    const payload = updatedConsents.map(item => {
      return {
        name: item.name,
        version: item.newestVersion,
        state: item.state
      };
    });
    this.setState({
      isSubmittingPending: true
    });
    (0, _submitConsents.default)([], [], payload).then(() => {
      this.setState({
        isSectionDisabled: true,
        isSubmittingPending: false
      });
      setConsents(updatedConsents);
    });
  }
  render() {
    const {
      t,
      consents,
      isLoading,
      showConsentsOnly
    } = this.props;
    const {
      updatedConsents,
      isSectionDisabled,
      isSubmittingPending,
      showButtonToUpdate
    } = this.state;
    const sortedConsents = updatedConsents.slice().sort((a, b) => {
      return a.required === b.required ? 0 : a.required ? -1 : 1;
    });
    return isLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {
      isMyAccount: true
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_MyAccountConsentsStyled.CardStyled, {
      showConsentsOnly: showConsentsOnly,
      withBorder: true,
      children: [sortedConsents.map(item => /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountConsentsStyled.CheckboxStyled, {
        isMyAccount: true,
        onClickFn: (e, isConsentDisabled) => this.handleClick(e, isConsentDisabled, item),
        checked: item.state === 'accepted',
        disabled: (isSectionDisabled || item.required) && !showConsentsOnly,
        required: item.required,
        hide: showConsentsOnly && !item.required,
        children: (0, _consentsHelper.default)(item.label, t)
      }, item.name)), !showConsentsOnly && /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: showButtonToUpdate && /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountConsentsStyled.ButtonWrapperStyled, {
          children: isSectionDisabled ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountConsentsStyled.ButtonStyled, {
            onClickFn: () => this.setState({
              isSectionDisabled: false
            }),
            width: "100%",
            children: t('Update Terms')
          }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountConsentsStyled.ButtonStyled, {
              theme: "simple",
              onClickFn: () => this.setState({
                isSectionDisabled: true,
                updatedConsents: consents
              }),
              children: t('Cancel')
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountConsentsStyled.ButtonStyled, {
              theme: "confirm",
              onClickFn: () => this.updateConsents(),
              disabled: isSubmittingPending,
              children: isSubmittingPending && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {
                buttonLoader: true,
                color: "#ffffff"
              }) || t('Save')
            })]
          })
        })
      })]
    });
  }
}
exports.PureMyAccountConsents = MyAccountConsents;
MyAccountConsents.propTypes = {
  consents: _propTypes.default.arrayOf(_propTypes.default.object),
  setConsents: _propTypes.default.func.isRequired,
  isLoading: _propTypes.default.bool,
  showConsentsOnly: _propTypes.default.bool,
  saveConsents: _propTypes.default.func,
  t: _propTypes.default.func
};
MyAccountConsents.defaultProps = {
  consents: [],
  isLoading: false,
  showConsentsOnly: false,
  saveConsents: () => {},
  t: k => k
};
var _default = exports.default = (0, _reactI18next.withTranslation)()(MyAccountConsents);